export default "/images/ko.png?f6e2007af5da3e9957923954109aa3ec";